import { render, staticRenderFns } from "./DocumentContainerComponent.vue?vue&type=template&id=39fadc0c&scoped=true"
import script from "./DocumentContainerComponent.vue?vue&type=script&lang=js"
export * from "./DocumentContainerComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentContainerComponent.vue?vue&type=style&index=0&id=39fadc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fadc0c",
  null
  
)

export default component.exports